import React, { useState, useEffect, useRef, useContext } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { CardsGrid, Loader, TextInputWithLabel, Button, ThemeContext, Drawer } from 'quantux-ui';
import WarningDialog from '../warning-dialog';
import { gray, blue, salmon, yellow } from '../../theme';
import { BASE_URL, DRAWER_BREAK_POINT, getHighlightedText, titleCase } from '../../utils';
import AccessOption from '../profile-access-manager/access-option';
import PracticeAccessManagerCard from './practice-access-manager-card';

const DOCS_PER_PAGE = 50;
const CARD_WIDTH = 360;

const providerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
  >
    <rect
      width="31"
      height="31"
      x=".5"
      y=".5"
      fill="#96C8FF"
      stroke="#002448"
      rx="3.5"
    />
    <path
      fill="#002448"
      d="M7.5 28.002a.443.443 0 0 1-.439-.376 7.61 7.61 0 0 1 .286-3.236c.032-.091.767-2.165 2.512-2.696a6.858 6.858 0 0 1 2.08-.35c.087 0 .171.025.244.073 1.35.886 2.5 1.484 3.722 1.525 1.222 0 2.296-.565 3.643-1.477a.398.398 0 0 1 .053-.031.49.49 0 0 1 .284-.09c1.623 0 2.879.504 3.732 1.499 1.578 1.839 1.164 4.663 1.146 4.783a.444.444 0 0 1-.878-.134c.004-.026.368-2.549-.945-4.074-.657-.765-1.646-1.163-2.94-1.186l-.008.004c-1.462.985-2.655 1.594-4.058 1.594h-.059c-1.392-.047-2.638-.67-4.066-1.597a6.181 6.181 0 0 0-1.691.31c-1.318.401-1.925 2.117-1.93 2.134a6.81 6.81 0 0 0-.25 2.815.442.442 0 0 1-.439.51Z"
    />
    <path
      fill="#002448"
      d="M13.582 26.182a.445.445 0 0 1-.41-.273l-1.643-3.95a.445.445 0 0 1 .82-.341l1.383 3.325 1.793-1.865a.445.445 0 1 1 .64.616l-2.264 2.353a.444.444 0 0 1-.32.135Z" /><path fill="#002448" d="M16.999 24.984a.442.442 0 0 1-.314-.13L15.53 23.7a.443.443 0 0 1 .484-.727.445.445 0 0 1 .144.1l1.154 1.154a.443.443 0 0 1-.313.757Z" /><path fill="#002448" d="M18.15 26.183a.442.442 0 0 1-.32-.136l-1.154-1.199a.444.444 0 1 1 .64-.615l.686.712 1.35-3.209a.444.444 0 0 1 .884.052v.045c0 .059-.011.117-.034.172l-1.643 3.906a.445.445 0 0 1-.41.272ZM22.555 27.29H19.98a.444.444 0 0 1 0-.887h2.575a.42.42 0 0 1 .444.444.445.445 0 0 1-.444.444ZM20.503 5.297a.433.433 0 0 0-.324-.12c-.062 0-.138.004-.222.004-.888-.004-2.752-.177-3.485-1.003a.398.398 0 0 0-.226-.155.118.118 0 0 0-.053-.014.208.208 0 0 0-.076-.009.22.22 0 0 0-.075.01.118.118 0 0 0-.054.013.403.403 0 0 0-.208.137c-.005.005-.01.014-.018.018a3.176 3.176 0 0 1-1.682.812c-.595.122-1.2.184-1.807.187-.08 0-.155 0-.218-.005a.471.471 0 0 0-.328.125.454.454 0 0 0-.133.32v3.76c0 .008.004.021.004.03a.532.532 0 0 0 .013.187.398.398 0 0 0 .058.124.455.455 0 0 0 .369.195.436.436 0 0 0 .128-.022c2.572-.8 5.326-.8 7.898 0a.443.443 0 0 0 .554-.288.247.247 0 0 0 .014-.08.334.334 0 0 0 0-.116.063.063 0 0 0 .008-.03v-3.76a.44.44 0 0 0-.137-.32Zm-.75 3.59a14.07 14.07 0 0 0-7.271.005V6.06c.097 0 .213-.004.337-.013.905-.053 2.38-.253 3.298-.994.919.74 2.393.94 3.298.994.125.009.24.013.338.013v2.828Z" /><path fill="#002448" d="M16.327 6.038v.64h.64v.45h-.64v.64h-.451v-.64h-.64v-.45h.64v-.64h.45Zm0-.444h-.451a.444.444 0 0 0-.444.444v.196h-.196a.444.444 0 0 0-.444.444v.45a.444.444 0 0 0 .444.444h.196v.196a.444.444 0 0 0 .444.444h.45a.444.444 0 0 0 .444-.444v-.196h.197a.444.444 0 0 0 .444-.444v-.45a.444.444 0 0 0-.444-.444h-.197v-.196a.444.444 0 0 0-.443-.444ZM18.827 13.743a.888.888 0 1 1-1.776 0 .888.888 0 0 1 1.776 0ZM15.276 13.743a.888.888 0 1 1-1.777 0 .888.888 0 0 1 1.777 0ZM16.161 18.179a3.397 3.397 0 0 1-1.53-.381.442.442 0 0 1-.092-.732.444.444 0 0 1 .49-.062 2.387 2.387 0 0 0 2.266 0 .444.444 0 1 1 .397.794 3.396 3.396 0 0 1-1.53.38Z" /><path fill="#002448" d="M16.163 21.083c-3.02 0-5.477-3.021-5.477-6.735l-.053-.61a.445.445 0 1 1 .884-.075l.055.647c.002 3.262 2.06 5.885 4.591 5.885 2.53 0 4.59-2.623 4.59-5.848a7.43 7.43 0 0 0-.026-.614.444.444 0 0 1 .885-.072c.018.226.028.455.028.687 0 3.713-2.457 6.735-5.477 6.735Z" /><path fill="#002448" d="M21.065 14.286a.876.876 0 0 1-.543-.194 2.331 2.331 0 0 1-.648-1.145.97.97 0 0 1-.146.064c-.648.228-1.44-.281-1.992-.752a.73.73 0 0 1-.073.06c-.465.33-1.298.022-2.069-.415a.549.549 0 0 1-.045.044c-.16.139-.523.45-2.194-.58-.448.927-1.317 2.535-2.088 2.868a.455.455 0 0 1-.603-.225 5.116 5.116 0 0 1-.176-.477 4.089 4.089 0 0 1 .86-4.12c.105-.111.218-.214.338-.308a.444.444 0 0 1 .547.7c-.087.068-.169.142-.245.222a3.179 3.179 0 0 0-.702 3.065 12.841 12.841 0 0 0 1.476-2.554.443.443 0 0 1 .65-.188c.432.29.886.544 1.36.758a.444.444 0 0 1 .688-.331 5.769 5.769 0 0 0 1.608.79.709.709 0 0 0-.012-.053.444.444 0 0 1 .756-.412c.59.635 1.38 1.157 1.621 1.071.051-.018.155-.164.186-.588a.444.444 0 0 1 .435-.412h.007a.444.444 0 0 1 .441.398c.05.585.203 1.156.452 1.688a2.65 2.65 0 0 0-.012-2.412 2.614 2.614 0 0 0-.642-.83 1.91 1.91 0 0 0-.192-.143.445.445 0 1 1 .475-.75c.099.065.194.135.284.21a3.6 3.6 0 0 1 .673 4.682l-.028.042a.538.538 0 0 1-.322.218.872.872 0 0 1-.125.009Z"
    />
  </svg>
);

const caseLedgerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
  >
    <path
      fill="#96C8FF"
      fillRule="evenodd"
      d="M16.8 5.053h4.8c1.332 0 2.4 1.124 2.4 2.526v13.895C24 22.876 22.932 24 21.6 24H2.4C1.068 24 0 22.876 0 21.474L.012 7.579c0-1.402 1.056-2.526 2.388-2.526h4.8V2.526C7.2 1.124 8.268 0 9.6 0h4.8c1.332 0 2.4 1.124 2.4 2.526v2.527Zm-7.2-.001h4.8V2.525H9.6v2.527Z"
      clipRule="evenodd"
    />
  </svg>
);

const paymentLedgerIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path fill="#96C8FF" fillRule="evenodd" d="M23.157 3a.843.843 0 0 0-.844.844v2.015A12.007 12.007 0 0 0 18.633 2 11.94 11.94 0 0 0 12.001 0a11.955 11.955 0 0 0-8.18 3.22 11.958 11.958 0 0 0-3.787 7.873.844.844 0 0 0 .778.904C.833 12 .854 12 .875 12a.845.845 0 0 0 .842-.78A10.278 10.278 0 0 1 4.97 4.454 10.28 10.28 0 0 1 12 1.687c2.04 0 4.01.593 5.7 1.718a10.303 10.303 0 0 1 3.488 3.907h-2.344a.843.843 0 1 0 0 1.688h4.313A.843.843 0 0 0 24 8.156V3.844A.843.843 0 0 0 23.157 3Zm.029 9.002a.845.845 0 0 0-.905.778 10.278 10.278 0 0 1-3.253 6.764A10.27 10.27 0 0 1 12 22.312a10.25 10.25 0 0 1-5.7-1.718 10.303 10.303 0 0 1-3.488-3.907h2.344a.843.843 0 1 0 0-1.688H.844a.843.843 0 0 0-.844.844v4.313a.843.843 0 1 0 1.687 0V18.14A12.025 12.025 0 0 0 5.365 22c1.968 1.308 4.26 2 6.635 2 3.046 0 5.953-1.145 8.179-3.221a11.944 11.944 0 0 0 3.785-7.872.843.843 0 0 0-.778-.905ZM10.653 9.833c0 .633.487 1.04 2 1.433 1.513.394 3.133 1.04 3.133 2.934 0 1.366-1.033 2.12-2.333 2.366V18h-2v-1.446c-1.28-.274-2.373-1.094-2.453-2.554h1.466c.074.787.614 1.4 1.987 1.4 1.473 0 1.8-.733 1.8-1.193 0-.62-.334-1.207-2-1.606-1.86-.447-3.133-1.214-3.133-2.754 0-1.286 1.04-2.126 2.333-2.406V6h2v1.46c1.393.34 2.093 1.393 2.14 2.54H14.12c-.04-.834-.48-1.4-1.667-1.4-1.127 0-1.8.506-1.8 1.233Z" clipRule="evenodd" />
  </svg>
);

const credentialingIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" fill="none">
    <path fill="#96C8FF" d="M24 11.444 21.338 8.4l.371-4.025-3.938-.895L15.709 0 12 1.593 8.29 0 6.23 3.48l-3.94.884.372 4.036L0 11.444l2.662 3.043-.371 4.037 3.938.894 2.062 3.491L12 21.305l3.71 1.593 2.06-3.48 3.94-.894-.372-4.026L24 11.444Zm-4.31 1.614-.61.71.087.926.197 2.128-2.99.676-.48.807-1.08 1.833-1.941-.84-.873-.37-.862.37-1.942.84-1.08-1.822-.48-.807-2.989-.676.197-2.138.087-.928-.611-.709-1.407-1.604L4.32 9.84l.61-.71-.097-.937-.197-2.117 2.99-.676.48-.807 1.08-1.833 1.941.84.873.37.862-.37 1.942-.84 1.08 1.833.48.807 2.989.676-.197 2.128-.087.927.611.709 1.407 1.604-1.396 1.614Z" /><path fill="#96C8FF" d="m9.916 13.364-2.53-2.542-1.615 1.625 4.145 4.157 8.008-8.03-1.615-1.625-6.393 6.415Z" />
  </svg>
);

const payerContractsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" fill="none">
    <path fill="#96C8FF" fillRule="evenodd" d="M4 0a4 4 0 0 0-4 4v20.8a4 4 0 0 0 4 4h20.8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Zm.202 5.829L14.488 2.4l10.286 3.429v10.285c0 5.681-4.605 10.286-10.286 10.286-5.681 0-10.286-4.604-10.286-10.286V5.83Zm18.644 10.283a8.357 8.357 0 0 1-16.715 0V7.273l8.357-2.946 8.358 2.946v8.84Zm-9.793-3.88c0 .633.487 1.04 2 1.433 1.514.393 3.133 1.04 3.133 2.933 0 1.367-1.033 2.12-2.333 2.367v1.433h-2v-1.446c-1.28-.274-2.373-1.094-2.453-2.554h1.466c.074.787.614 1.4 1.987 1.4 1.473 0 1.8-.733 1.8-1.193 0-.62-.333-1.207-2-1.607-1.86-.446-3.133-1.213-3.133-2.753 0-1.287 1.04-2.127 2.333-2.407v-1.44h2v1.46c1.394.34 2.094 1.394 2.14 2.54H16.52c-.04-.833-.48-1.4-1.667-1.4-1.127 0-1.8.507-1.8 1.234Z" clipRule="evenodd" />
  </svg>
);

const practiceAffiliationIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" fill="none">
    <path fill="#96C8FF" fillRule="evenodd" d="M17.998 10.127c.688.302 1.31.721 1.858 1.253a6.002 6.002 0 0 1 1.858 4.315V20.1c0 1.338-1.123 2.426-2.5 2.426h-6.818c-.39.887-1.297 1.475-2.299 1.475H2.5C1.12 24 0 22.91 0 21.574v-4.401c0-1.627.658-3.161 1.85-4.318a6.239 6.239 0 0 1 1.858-1.253 5.5 5.5 0 0 1-1.993-1.737A5.234 5.234 0 0 1 .76 6.848c0-2.963 2.483-5.373 5.536-5.373 1.552 0 3.009.623 4.055 1.715A5.39 5.39 0 0 1 12.209.99 5.615 5.615 0 0 1 15.41 0c3.053 0 5.536 2.41 5.536 5.373 0 1.085-.33 2.127-.955 3.02a5.468 5.468 0 0 1-1.993 1.734Zm-2.59-8.229c-.957 0-1.855.361-2.53 1.018a3.389 3.389 0 0 0-1.048 2.456c0 .93.372 1.801 1.049 2.456a3.598 3.598 0 0 0 2.53 1.018c.958 0 1.855-.361 2.53-1.018a3.4 3.4 0 0 0 0-4.912 3.598 3.598 0 0 0-2.53-1.018ZM2.715 6.848c0-.93.372-1.8 1.049-2.455a3.598 3.598 0 0 1 2.53-1.018c.958 0 1.855.36 2.53 1.018a3.398 3.398 0 0 1 0 4.911 3.598 3.598 0 0 1-2.53 1.018c-.955 0-1.856-.36-2.533-1.018A3.401 3.401 0 0 1 2.714 6.85Zm7.76 15.094a.502.502 0 0 0 .159-.37v-4.397a4.116 4.116 0 0 0-1.23-2.929l-.009-.01a4.372 4.372 0 0 0-3.1-1.275c-1.153 0-2.24.438-3.064 1.237a4.118 4.118 0 0 0-1.274 2.974v4.4c0 .29.242.524.54.524h7.597a.544.544 0 0 0 .38-.154Zm-.328-9.596a6.254 6.254 0 0 0-1.267-.745 5.475 5.475 0 0 0 2.472-2.568c.424.44.92.812 1.468 1.093a6.291 6.291 0 0 0-1.859 1.253c-.305.3-.578.622-.814.967Zm9.064 8.277c.297 0 .54-.236.54-.524v-4.404c0-1.12-.452-2.175-1.275-2.973a4.372 4.372 0 0 0-3.064-1.238 4.37 4.37 0 0 0-3.87 2.314 5.913 5.913 0 0 1 1.051 3.372v3.453h6.618Z" clipRule="evenodd" />
  </svg>
);

const facilityPrivilegeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path fill="#96C8FF" fillRule="evenodd" d="M0 1a1 1 0 0 1 1-1h13.852a1 1 0 0 1 1 1v22.995H0V1Zm4.533 11.998h6.79v9.998h-6.79v-9.998Zm0-2.753h1.542V7.27h3.708v2.98h1.542V2.822H9.783v2.963H6.075V2.818H4.533v7.427Zm11.826-4.79h6.637a1 1 0 0 1 1 1v17.542H16.36V5.455Zm1.092 2.18h2.182v2.18h-2.182v-2.18Zm5.454 0h-2.182v2.18h2.182v-2.18Zm-2.182 3.276h2.182v2.181h-2.182v-2.181Zm-1.09 0h-2.182v2.181h2.182v-2.181Zm-2.182 3.267h2.182v2.181h-2.182v-2.181Zm5.454 0h-2.182v2.181h2.182v-2.181Z" clipRule="evenodd" />
  </svg>
);

const collaboratorsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path fill="#96C8FF" fillRule="evenodd" d="M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm14 8c0 2.213-1.787 4-4 4s-4-1.787-4-4 1.787-4 4-4 4 1.787 4 4ZM4 18.667c0-2.667 5.333-4.134 8-4.134s8 1.467 8 4.134V20H4v-1.333Z" clipRule="evenodd" />
  </svg>
);

const profileAccessManagerIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" fill="none">
    <path fill="#96C8FF" fillRule="evenodd" d="M15.997 8h-1.143V5.714A5.716 5.716 0 0 0 9.141 0a5.716 5.716 0 0 0-5.713 5.714V8H2.285A2.292 2.292 0 0 0 0 10.286v11.428A2.292 2.292 0 0 0 2.285 24h13.712a2.292 2.292 0 0 0 2.285-2.286V10.286A2.292 2.292 0 0 0 15.997 8ZM9.142 18.286A2.292 2.292 0 0 1 6.857 16a2.292 2.292 0 0 1 2.285-2.286A2.292 2.292 0 0 1 11.428 16a2.292 2.292 0 0 1-2.286 2.286ZM5.712 5.764v2.24h6.856v-2.24c0-1.916-1.537-3.474-3.428-3.474-1.89 0-3.428 1.558-3.428 3.474Z" clipRule="evenodd" />
  </svg>
);

const PracticeAccessManagersGrid = (props) => {
  const [gridData, setGridData] = useState([]);
  const [gridWidth, setGridWidth] = useState(window.innerWidth <= 768 ? window.innerWidth - 16 : 550);
  const [gridHeight, setGridHeight] = useState(window.innerHeight - 143);
  const [showLoader, setShowLoader] = useState(false);
  const [docsCount, setDocsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState({});
  const [sorting, setSorting] = useState({});
  const [isFiltered, setIsFiltered] = useState(false);
  // -- Add Profile Manager Drawer
  const [showAddProfileManagerDrawer, setShowAddProfileManagerDrawer] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [searchingUsers, setSearchingUsers] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showManagerDeleteWarning, setShowManagerDeleteWarning] = useState(false);
  const [activeProfileManager, setActiveProfileManager] = useState({});
  const [activeProfilePermission, setActiveProfilePermission] = useState(0);
  const [activeCaseLedgerPermission, setActiveCaseLedgerPermission] = useState(0);
  const [activePaymentLedgerPermission, setActivePaymentLedgerPermission] = useState(0);
  const [activeCredentialingPermission, setActiveCredentialingPermission] = useState(0);
  const [activeProfileAccessManagerPermission, setActiveProfileAccessManagerPermission] = useState(0);
  const [activeInsurancePermission, setActiveInsurancePermission] = useState(0);
  const [activeProvidersPermission, setActiveProvidersPermission] = useState(0);
  const [activeFacilityCoveragePermission, setActiveFacilityCoveragePermission] = useState(0);
  const [activeCollaboratorsPermission, setActiveCollaboratorsPermission] = useState(0);
  const [loaderMsg, setLoaderMsg] = useState('Loading Data...');
  // -- Edit Permissions Drawer
  const [currentUser, setCurrentUser] = useState({});
  const [showEditPermissionsDrawer, setShowEditPermissionsDrawer] = useState(false);
  const [showAccessManagerWarning, setShowAccessManagerWarning] = useState(false);
  // -- Refs
  const gridParentRef = useRef();

  const context = useContext(ThemeContext);
  const { isTouchDevice } = context.theme;

  let gcHeightDiff = '25px';
  if (isTouchDevice) {
    if (/iPhone/ig.test(window.navigator.userAgent)) {
      gcHeightDiff = '105px';
    } else {
      gcHeightDiff = '50px';
    }
  }

  // -- Active Permissions Effect ---------------------------------------
  useEffect(() => {
    const { access = {} } = activeProfileManager;
    const {
      profile = 0,
      caseLedger = 0,
      paymentsLedger = 0,
      credentialing = 0,
      insurance = 0,
      providers = 0,
      collaborators = 0,
      facilityCoverage = 0,
      accessManager = 0
    } = access;

    setActiveProfilePermission(profile);
    setActiveCaseLedgerPermission(caseLedger);
    setActivePaymentLedgerPermission(paymentsLedger);
    setActiveCredentialingPermission(credentialing);
    setActiveInsurancePermission(insurance);
    setActiveCollaboratorsPermission(collaborators);
    setActiveFacilityCoveragePermission(facilityCoverage);
    setActiveProvidersPermission(providers);
    setActiveProfileAccessManagerPermission(accessManager);
    setShowAccessManagerWarning(accessManager === 6);
    console.log(access);
  }, [activeProfileManager]);

  // -- Styles ----------------------------------------------------------
  const styles = StyleSheet.create({
    gridContainer: {
      height: `calc(100% - ${gcHeightDiff})`,
      overflowY: 'hidden',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    gridToolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '40px',
      // border: '1px solid black',
      // borderBottom: 'none',
      marginBottom: '2px',
      paddingLeft: '4px',
      background: gray[500],
      width: '100%'
    },
    gridToolbarIcon: {
      height: '50px',
      width: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      ':hover': {
        color: blue[500]
      }
    },
    addUserBtn: {
      color: blue[400],
      cursor: 'pointer'
    },
    gridCard: {
      background: gray[500],
      color: blue[200],
      paddingBottom: '4px'
    },
    bulletItem: {
      fontSize: '10px'
    },
    cardHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '14px',
      padding: '4px',
      height: '48px',
      overflow: 'hidden',
      borderBottom: `1px solid ${gray[800]}`
    },
    cardDataContainer: {
      height: '180px',
      overflowY: 'auto',
      padding: '8px'
    },
    drawerContainer: {
      // background: gray[500],
      background: gray[800],
      color: gray[300],
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    drawerHeader: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0'
    },
    drawerHeaderCloseIcon: {
      color: gray[300],
      ':hover': {
        color: salmon[500]
      }
    },
    drawerBanner: {
      position: 'relative',
      padding: '8px 0 0 2px',
      flexShrink: '0'
    },
    drawerBannerImg: {
      width: '100%',
      height: 'auto'
    },
    drawerBannerCameraIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      right: '0',
      bottom: '8px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerContentArea: {
      // height: 'calc(100vh - 186px)',
      overflowY: 'auto',
      color: gray[300],
      flexGrow: '1'
    },
    drawerUserCardAvatar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      color: 'white',
      borderRadius: '4px',
      position: 'relative'
    },
    drawerUserCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px'
    },
    drawerAvatarCamera: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      left: '-3px',
      top: '58px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerUserCardText: {
      fontSize: '12px'
    },
    drawerFooter: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      background: gray[700],
      height: '56px',
      width: '100%',
      borderTop: `1px solid ${gray[500]}`,
      flexShrink: '0'
    },
    accessOption: {
      marginTop: '2px'
    },
    accessManagerWarning: {
      color: yellow[500],
      fontSize: '14px',
      padding: '8px'
    }
  });

  const getData = async () => {
    let practiceNpi = '0';
    if (props.practiceNpi) {
      practiceNpi = props.practiceNpi;
    }

    setLoaderMsg('Loading Data...');
    setShowLoader(true);
    const formData = new FormData();
    formData.append('practiceNpi', practiceNpi);

    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };

    const dataPromise = fetch(`${BASE_URL}/practice/getPracticeAccessManagers`, requestOptions);
    const countPromise = fetch(`${BASE_URL}/practice/getPracticeAccessManagersCount`, requestOptions);

    const response = await Promise.all([dataPromise, countPromise])
      .catch(err => {
        console.log('Error getting user profile managers grid data and count');
        console.log(err);
      });

    if (response) {
      const dataResponse = await response[0].json();
      const countResponse = await response[1].json();

      if (dataResponse && dataResponse.success) {
        console.log(dataResponse);
        setGridData(dataResponse.accessManagers);
        setShowLoader(false);
      }

      if (countResponse && countResponse.success) {
        console.log(`[Debug] Total access managers count = ${countResponse.accessManagersCount}`);
        setDocsCount(countResponse.accessManagersCount);
      }
    }
  };

  const handleWindowResize = () => {
    if (gridParentRef && gridParentRef.current) {
      const gridParentRefWidth = gridParentRef.current.getBoundingClientRect().width;
      console.log(`gridParentRef width = ${gridParentRefWidth}`);
      // const tmp = window.innerWidth <= 768 ? window.innerWidth - 16 : Math.ceil(0.75 * gridParentRefWidth);
      const tmp = window.innerWidth <= 768 ? window.innerWidth - 16 : gridParentRefWidth;
      console.log(`GridWidth = ${tmp}`);
      // setGridWidth(Math.min(tmp, 1111));
      setGridWidth(Math.min(tmp, 1111));
      // setGridHeight(window.innerHeight - 400);
      setGridHeight(window.innerHeight - 150);
      // setMobileLayout(window.innerWidth <= DRAWER_BREAK_POINT);
    }
  };

  // Get cards grid data
  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    getData();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [filters, currentPage, sorting]);

  useEffect(() => {
    if (search.length === 0) {
      getData();
    }
  }, [search]);

  const handleOnEditSearch = (e) => {
    const { value } = e.target;
    setIsFiltered(false);
    setSearch(value);
  };

  const handleOnClickSearch = () => {
    getData();
  };

  const handleOnClickResetFilters = () => {
    setSearch('');
  };

  // #region Add Prorifle Mangers Drawer Event Handlers
  const handleOnEditFirstName = (e) => {
    const { value } = e.target;
    setFirstName(value);
  };

  const handleOnEditLastName = (e) => {
    const { value } = e.target;
    setLastName(value);
  };

  const handleOnClickSearchUsers = () => {
    const url = new URL(`${BASE_URL}/users/searchMedProsByName`);
    const params = { firstName, lastName };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then(response => response.text())
      .then(result => {
        const data = JSON.parse(result);
        console.log(data.users);
        setSearchResults(data.users);
      })
      .catch(error => console.log('error', error));
  };

  const handleOnClickAddProfileManager = async (data) => {
    let practiceNpi = '';
    if (props.practiceNpi) {
      practiceNpi = props.practiceNpi;
    }
    const formData = new FormData();
    formData.append('practiceNpi', practiceNpi);
    formData.append('managerId', data._id);
    // Request Headers incl Authorization
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };
    const response = await fetch(`${BASE_URL}/practice/addPracticeAccessManager`, requestOptions);
    const result = await response.json();
    if (result.success) {
      setShowAddProfileManagerDrawer(false);
      getData();
    }
  };

  const handleOnClickDeleteProfileManager = async (data) => {
    setActiveProfileManager(data);
    setShowManagerDeleteWarning(true);
  };

  const deleteProfileManager = async () => {
    const { _id: managerId } = activeProfileManager;
    let practiceNpi = '';
    if (props.practiceNpi) {
      practiceNpi = props.practiceNpi;
    }
    const formData = new FormData();
    formData.append('practiceNpi', practiceNpi);
    formData.append('managerId', managerId);
    // Request Headers incl Authorization
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };
    const response = await fetch(`${BASE_URL}/practice/removePracticeAccessManager`, requestOptions);
    const result = await response.json();
    if (result.success) {
      getData();
    }
  };

  const handleOnClickEditPermissions = (data) => {
    setActiveProfileManager(data);
    setShowEditPermissionsDrawer(true);
    console.log(data);
  };

  const handleOnClickSavePermissions = async () => {
    const { _id: managerId } = activeProfileManager;
    let practiceNpi = '';
    if (props.practiceNpi) {
      practiceNpi = props.practiceNpi;
    }
    const formData = new FormData();
    formData.append('practiceNpi', practiceNpi);
    formData.append('managerId', managerId);
    formData.append('activeProfilePermission', activeProfilePermission);
    formData.append('activeCaseLedgerPermission', activeCaseLedgerPermission);
    formData.append('activePaymentLedgerPermission', activePaymentLedgerPermission);
    formData.append('activeCredentialingPermission', activeCredentialingPermission);
    formData.append('activeProfileAccessManagerPermission', activeProfileAccessManagerPermission);
    formData.append('activeInsurancePermission', activeInsurancePermission);
    formData.append('activeProvidersPermission', activeProvidersPermission);
    formData.append('activeFacilityCoveragePermission', activeFacilityCoveragePermission);
    formData.append('activeCollaboratorsPermission', activeCollaboratorsPermission);
    formData.append('privilegeLevel', 'custom');
    // Request Headers incl Authorization
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };
    const response = await fetch(`${BASE_URL}/practice/updatePracticeAccessManagerPermissions`, requestOptions);
    const result = await response.json();
    console.log(result);
    if (result.success) {
      setShowEditPermissionsDrawer(false);
      getData();
    }
  };

  const handleOnUpdatePrivilegeLevel = (pData) => {
    let practiceNpi = '';
    if (props.practiceNpi) {
      practiceNpi = props.practiceNpi;
    }
    const formData = new FormData();
    formData.append('practiceNpi', practiceNpi);
    formData.append('managerId', pData._id);
    formData.append('activeProfilePermission', pData.access.profile);
    formData.append('activeCaseLedgerPermission', pData.access.caseLedger);
    formData.append('activePaymentLedgerPermission', pData.access.paymentsLedger);
    formData.append('activeCredentialingPermission', pData.access.credentialing);
    formData.append('activeProfileAccessManagerPermission', pData.access.accessManager);
    formData.append('activeInsurancePermission', pData.access.insurance);
    formData.append('activeProvidersPermission', pData.access.providers);
    formData.append('activeFacilityCoveragePermission', pData.access.facilityCoverage);
    formData.append('activeCollaboratorsPermission', pData.access.collaborators);
    formData.append('privilegeLevel', pData.access.privilegeLevel);
    // Request Headers incl Authorization
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };
    fetch(`${BASE_URL}/practice/updatePracticeAccessManagerPermissions`, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        if (data.success) {
          getData();
        }
      })
  };
  // #endregion

  const drawerWidth = window.innerWidth <= DRAWER_BREAK_POINT ? window.innerWidth : 320;

  return (
    <div ref={gridParentRef} className={`p-2 ${css(styles.gridContainer)}`}>
      {showLoader &&
        <Loader
          iconType="cog"
          iconSize="5x"
          text={loaderMsg}
          style={{
            position: 'absolute',
            background: 'black',
            opacity: '0.9'
          }}
        />
      }
      {/* Add Access Manager Drawer */}
      {showAddProfileManagerDrawer &&
        <Drawer
          placement="right"
          visible={showAddProfileManagerDrawer}
          toggleDrawer={() => {
            setShowAddProfileManagerDrawer(false);
          }}
          zIndex="2000"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div className='fx fx__hv-center'>
                <i className='mr-2 fa fa-lg fa-user' />
                <div className='noselect'>Add Profile Manager</div>
              </div>
              <i
                className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => {
                  setShowAddProfileManagerDrawer(false);
                }}
              />
            </div>
            {/* Middle Area */}
            <div className={css(styles.drawerContentArea)}>
              <div className='p-1'>
                <div className='pl-2 pr-2'>
                  <div className='mt-3'>
                    {/* First Name, Last Name and NPI */}
                    <div className='fx'>
                      {/* First Name */}
                      <TextInputWithLabel
                        value={firstName}
                        titleText="First Name"
                        titleFontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={166}
                        onChange={handleOnEditFirstName}
                      />
                      {/* Last Name */}
                      <TextInputWithLabel
                        value={lastName}
                        className='ml-2'
                        titleText="Last Name"
                        titleFontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={166}
                        placeholder='Required'
                        onChange={handleOnEditLastName}
                      />
                    </div>
                    {/* Search Button */}
                    <Button
                      className='mt-4'
                      btnType='primary'
                      isDisabled={lastName.length === 0}
                      showLoader={searchingUsers}
                      onClick={handleOnClickSearchUsers}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '32px'
                      }}
                    >
                      {searchingUsers ? 'Searching... Click to Cancel' : 'Search'}
                    </Button>
                  </div>
                  {/* Practice Providers Cards */}
                  <div
                    className='mt-2 pl-2 pr-2'
                    style={{
                      height: 'calc(100vh - 270px)',
                      overflowY: 'auto'
                    }}
                  >
                    {searchResults.map((el) => {
                      const duplicateIndex = gridData.findIndex(row => row._id === el._id);
                      // console.log(`Duplicate index = ${duplicateIndex}`);
                      return (
                        <div
                          key={el._id}
                          className='fx mt-1 p-1'
                          style={{
                            background: blue[900],
                            borderRadius: '4px',
                            fontSize: '14px',
                            fontWeight: '700'
                          }}
                        >
                          {/* Data */}
                          <div style={{ flexGrow: '1' }}>
                            <div>
                              {`${titleCase(el.lastName)}, ${titleCase(el.firstName)}`}
                            </div>
                            <div style={{ color: blue[400] }}>
                              {`@${el.userName}`}
                            </div>
                          </div>
                          {/* Button */}
                          <div>
                            <Button
                              isDisabled={duplicateIndex > -1}
                              style={{
                                maxWidth: '130px',
                                minWidth: '130px',
                                maxHeight: '32px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '4px',
                                fontSize: '14px',
                                lineHeight: '14px',
                                fontWeight: '700'
                              }}
                              onClick={() => {
                                handleOnClickAddProfileManager(el);
                              }}
                            >
                              Add<br />Profile Manager
                            </Button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      }

      {/* Edit permissions drawer */}
      {showEditPermissionsDrawer &&
        <Drawer
          placement="right"
          visible={showEditPermissionsDrawer}
          toggleDrawer={() => {
            setShowEditPermissionsDrawer(false);
          }}
          zIndex="2000"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div className='fx fx__hv-center'>
                <div className='mr-1 noselect'>Profile Access Manager</div>
              </div>
              <i
                className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => {
                  setShowEditPermissionsDrawer(false);
                }}
              />
            </div>
            {/* Middle Area */}
            <div className={css(styles.drawerContentArea)}>
              {/* Info section */}
              <div className='p-2' style={{ borderBottom: '1px solid' }}>
                <div>
                  {`Profile Access Management for user "${activeProfileManager.firstName} ${activeProfileManager.lastName}"`}
                </div>
                <div>
                  <span>{`Regardless of the level of access you allow ${activeProfileManager.firstName} for your PROFILE PAGE tabs, ${activeProfileManager.firstName} `}</span>
                  <span style={{ color: yellow[500] }}>WILL NOT</span>&nbsp;
                  <span>be able to view or modify any items in your account that are located OUTSIDE of this PROFILE PAGE. This includes:</span>
                  <ul style={{ margin: '8px 0' }}>
                    <li>Changing your login credentials</li>
                    <li>Adding payment methods</li>
                    <li>Changing your account settings</li>
                  </ul>
                </div>
              </div>
              {/* Profile Manager Access Settings */}
              <div className='p-2'>
                <div style={{ color: blue[200] }}>
                  Profile Access Manager Settings
                </div>
                {/* Profile */}
                <AccessOption
                  text='Profile'
                  svgIcon={providerIcon}
                  className='mt-2'
                  disableNoAccess
                  permission={activeProfilePermission}
                  onChange={(val) => setActiveProfilePermission(val)}
                />
                {/* Case Ledger */}
                <AccessOption
                  text='Case Ledger'
                  svgIcon={caseLedgerIcon}
                  className={css(styles.accessOption)}
                  permission={activeCaseLedgerPermission}
                  onChange={(val) => setActiveCaseLedgerPermission(val)}
                />
                {/* Payments Ledger */}
                <AccessOption
                  text='Payments Ledger'
                  svgIcon={paymentLedgerIcon}
                  className={css(styles.accessOption)}
                  permission={activePaymentLedgerPermission}
                  onChange={(val) => setActivePaymentLedgerPermission(val)}
                />
                {/* Credentialing */}
                <AccessOption
                  text='Credentialing'
                  svgIcon={credentialingIcon}
                  className={css(styles.accessOption)}
                  permission={activeCredentialingPermission}
                  onChange={(val) => setActiveCredentialingPermission(val)}
                />
                {/* Insurance */}
                <AccessOption
                  text='Insurance'
                  svgIcon={payerContractsIcon}
                  className={css(styles.accessOption)}
                  permission={activeInsurancePermission}
                  onChange={(val) => setActiveInsurancePermission(val)}
                />
                <div className='mt-2 mb-2' style={{ color: blue[200] }}>
                  Providers/Collaborators/Coverage
                </div>
                {/* Providers */}
                <AccessOption
                  text='Providers'
                  svgIcon={providerIcon}
                  className={css(styles.accessOption)}
                  permission={activeProvidersPermission}
                  onChange={(val) => setActiveProvidersPermission(val)}
                />
                {/* Collaborators */}
                <AccessOption
                  text='Collaborators'
                  svgIcon={collaboratorsIcon}
                  className={css(styles.accessOption)}
                  permission={activeCollaboratorsPermission}
                  onChange={(val) => setActiveCollaboratorsPermission(val)}
                />
                {/* Facility Coverage */}
                <AccessOption
                  text='Facility Coverage'
                  svgIcon={facilityPrivilegeIcon}
                  className={css(styles.accessOption)}
                  permission={activeFacilityCoveragePermission}
                  onChange={(val) => setActiveFacilityCoveragePermission(val)}
                />
                {/* Access Manager */}
                <AccessOption
                  text='Access Manager'
                  svgIcon={profileAccessManagerIcon}
                  className={css(styles.accessOption)}
                  showWarning={showAccessManagerWarning}
                  permission={activeProfileAccessManagerPermission}
                  onChange={(val) => {
                    setShowAccessManagerWarning(val === 6);
                    setActiveProfileAccessManagerPermission(val);
                  }}
                />
              </div>
              {/* Access Manager read/write warning */}
              {showAccessManagerWarning &&
                <div className={`fx ${css(styles.accessManagerWarning)}`}>
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" fill="none">
                      <path fill="#FF0" fillRule="evenodd" d="M.162 11.785a1 1 0 0 0 .84 1.543h13.664a1 1 0 0 0 .84-1.543L8.673 1.226a1 1 0 0 0-1.679 0L.162 11.786Zm8.668-.32a.996.996 0 1 1-1.993 0 .996.996 0 0 1 1.993 0Zm-.997-1.874c.55 0 .997-.446.997-.996V4.609a.996.996 0 1 0-1.993 0v3.986c0 .55.446.996.996.996Z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className='ml-2'>
                    <div>
                      {`By granting Read/Write Access to ${activeProfileManager.firstName} for the "Profile Access Manager" tab, you are enabling ${activeProfileManager.firstName} to manage this tab as if ${activeProfileManager.firstName} were YOU.`}
                    </div>
                    <div className='mt-2'>
                      {`This means that ${activeProfileManager.firstName} will be able to grant access to OTHER users to view and/or manage`}
                    </div>
                    <div className='mt-2'>
                      {`If you do not want to grant ${activeProfileManager.firstName} this level of access, select “None” or "Read Only"`}
                    </div>
                  </div>
                </div>
              }
            </div>
            {/* Footer */}
            <div className={`fx pr-2 ${css(styles.drawerFooter)}`} >
              <Button
                btnType="primary"
                isOutlineBtn
                className="fx fx__hv-center mr-2"
                onClick={() => setShowEditPermissionsDrawer(false)}
                style={{
                  height: '32px',
                  width: '85px',
                  padding: '3px 0'
                }}
              >
                Cancel
              </Button>
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                onClick={handleOnClickSavePermissions}
                style={{
                  height: '32px',
                  width: '85px',
                  padding: '3px 0'
                }}
              >
                Accept
              </Button>
            </div>
          </div>
        </Drawer>
      }

      {/* Delete Warning Dialog */}
      {showManagerDeleteWarning &&
        <WarningDialog
          show={showManagerDeleteWarning}
          title='Delete Profile Manager'
          message={`Do you want to remove ${activeProfileManager.lastName}, ${activeProfileManager.firstName} from managing your profile access manager feature?`}
          onCancel={() => setShowManagerDeleteWarning(false)}
          onContinue={() => {
            setShowManagerDeleteWarning(false);
            setLoaderMsg('Deleting profile manager...');
            setShowLoader(true);
            deleteProfileManager();
          }}
        />
      }

      {/* Grid Toolbar */}
      <div className={css(styles.gridToolbar)}>
        {/* Grid toolbar - left aligned search */}
        <div className='fx' style={{ alignItems: 'center' }}>
          {props.premissionMode === 6 &&
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23"
                height="22"
                fill="none"
              >
                <path
                  fill="#00A0FF"
                  fillRule="evenodd"
                  d="M12.622 10.745c3.04 0 5.493-2.4 5.493-5.372C18.115 2.4 15.662 0 12.622 0 9.582 0 7.13 2.4 7.13 5.373c0 2.972 2.454 5.372 5.493 5.372Zm-.805 2.707C7.877 13.452 0 15.746 0 19.915V22h13.924a6.106 6.106 0 0 1-.68-2.81c0-2.138 1.1-4.026 2.776-5.152-1.541-.387-3.043-.586-4.203-.586Zm7.734 8.401h-1.227v-2.4H15.87v-1.2h2.454v-2.4h1.227v2.4h2.454v1.2H19.55v2.4Z"
                  clipRule="evenodd"
                />
              </svg>
              <div
                className={`${css(styles.addUserBtn)} ml-2 noselect`}
                onClick={() => {
                  setFirstName('');
                  setLastName('');
                  setSearchResults([]);
                  setShowAddProfileManagerDrawer(true);
                }}
              >
                Add User
              </div>
            </>
          }
        </div>
        {/* Grid toolbar - right aligned buttons */}
        <div className='fx'>
          {/* Reset button */}
          <div
            className={css(styles.gridToolbarIcon)}
            onClick={handleOnClickResetFilters}
          >
            <i className="fa fa-lg fa-refresh" />
          </div>
          {/* Vertical ellipsis */}
          <div
            className={css(styles.gridToolbarIcon)}
            style={{ fontSize: '16px' }}
          >
            <span className='fa-stack'>
              <i className='fa fa-circle fa-stack-2x' />
              <i
                className='fa fa-ellipsis-v fa-stack-1x'
                style={{ color: gray[700] }}
              />
              {/* <i class="fa fa-flag fa-stack-1x fa-inverse"></i> */}
            </span>
          </div>
        </div>
      </div>
      <CardsGrid
        rowData={gridData}
        gridWidth={gridWidth}
        gridHeight={gridHeight}
        loader={false}
        style={{ flexGrow: '1', overflowY: 'auto' }}
        cardHeight='190px'
        cardWidth={`${CARD_WIDTH}px`}
        totalPages={Math.ceil(docsCount / DOCS_PER_PAGE)}
        currentPage={currentPage}
        onLoadPage={(page) => { setCurrentPage(page); }}
        cardRenderer={(data) => (
          <PracticeAccessManagerCard
            data={data}
            premissionMode={props.premissionMode}
            onDeleteManager={(data) => {
              handleOnClickDeleteProfileManager(data);
            }}
            onChangePrivilegeLevel={(updatedData) => {
              if (updatedData.access.privilegeLevel !== 'custom') {
                handleOnUpdatePrivilegeLevel(updatedData);
              } else {
                setActiveProfileManager(updatedData);
                setShowEditPermissionsDrawer(true);
              }
            }}
            onEditPermissions={() => {
              handleOnClickEditPermissions(data);
            }}
          />
        )}
      />
    </div>
  );
};

PracticeAccessManagersGrid.defaultProps = {
  premissionMode: 0
};
export default PracticeAccessManagersGrid;
